import axios from "axios";
export const ResetExpiredPassword = {
  data: () => ({}),
  methods: {
    async ResetExpiredPasswordMethod(user_email_id, old_password, new_password) {
      try {
        var data = JSON.stringify({
          command: "resetPassword",
          user_email_id,
          old_password,
          new_password,
        });
        var config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://cmjo10iqb9.execute-api.ap-south-1.amazonaws.com/dev/user_auth/signin",
          headers: {},
          data: data,
        };

        let result = await axios(config);
        return result;
      } catch (error) {
        return {
          status: error.response.status,
          statusText: "FAILURE",
          error: error.response.data.Model,
        };
      }
    },
  },
};
